import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import { selectListItems } from "../../../../../redux/library/selector";
import PageLoader from "../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectAnnouncementsListItems } from "../../../../../redux/announcements/selector";
import { announcements } from "../../../../../redux/announcements/action";

const ManagementAnnouncements = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectAnnouncementsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
  
      { field: 'Title', headerName: 'Title' },
      { field: 'AnnouncmentTypeId', headerName: 'Announcment Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.AnnouncementType } },
      { field: 'Description', headerName: 'Description' },
      { field: 'CreatedOnUtc', headerName: 'CreatedOn On', isDateValueFormat: true  },
      { field: 'StartDateUtc', headerName: 'StartDate On', isDateValueFormat: true },
      { field: 'EndDateUtc', headerName: 'EndDate On', isDateValueFormat: true  }
    ]);
  }

  const additionButtons: any = [
    {
      name: 'Add Announcements',
      callback: () => handleAdd(),
    }
  ];

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }


  const handleDelete = (data: any) => {
    dispatch(announcements.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/delete`,
      entity: 'announcements',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      dispatch(announcements.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/list`,
        entity: 'announcements',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }

  const fetchAnnouncements = () => {
    dispatch(announcements.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/list`,
      entity: 'announcements',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchAnnouncements()
  }, [pageData])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} 
          additionButtons={additionButtons} headingName="Announcements" />
      }
    </>
  );
};

export default ManagementAnnouncements;


